<template>
  <div style="background-color: white">
    <a-layout id="">

      <a-breadcrumb style="padding: 16px 24px">
        <a-breadcrumb-item>
          <router-link :to="{name:'scf'}">
            <a-icon type="home"/>
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <span>个人中心</span>
        </a-breadcrumb-item>
      </a-breadcrumb>

      <a-layout-content>
        <a-layout>
          <a-layout-sider
            width="120"
            breakpoint="lg"
            collapsed-width="0"
            theme="light"
            height="100%"
          >
            <a-menu theme="light" mode="inline"
                    v-model="selectedKeys">
              <a-menu-item key="0">
                <span class="nav-text">基本信息</span>
              </a-menu-item>
              <a-menu-item key="1">
                <span class="nav-text">修改密码</span>
              </a-menu-item>
            </a-menu>
          </a-layout-sider>
          <a-layout-content style="background-color: white">
            <a-row>
              <!--info modify-->
              <a-col
                :span="24"
                :xxl="{span:12}"
                :xl="{span:12}"
                :lg="{span:12}"
                :md="{span:16}"
                style="padding:2rem"
                v-if="selectedKeys[0]==='0' && modify">

                <h3 style="text-align: center">修改个人信息</h3>
                <a-divider></a-divider>
                <a-form-model
                  ref="ruleForm"
                  :model="form"
                  :rules="rules"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                >
                  <a-form-model-item ref="name" label="姓名" prop="name">
                    <a-input
                      v-model="form.name"
                      @blur="
          () => {
            $refs.name.onFieldBlur();
          }"/>
                  </a-form-model-item>
                  <a-form-model-item label="出生年月" required prop="birthday">
                    <a-date-picker
                      v-model="form.birthday"
                      @change="error.birthday=''"
                      type="date"
                      placeholder="选择一个日期"
                      valueFormat="YYYY-MM-DD"
                      style="width: 100%;"
                    />
                    <span class="text-danger" v-if="error.birthday">{{ error.birthday }}</span>
                  </a-form-model-item>

                  <a-form-model-item label="性别" prop="gender">
                    <a-radio-group v-model="form.gender">
                      <a-radio value="male">
                        男
                      </a-radio>
                      <a-radio value="female">
                        女
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                  <a-form-model-item label="民族" required prop="nation">

                    <a-select
                      show-search
                      placeholder="选择民族"
                      option-filter-prop="children"
                      :filter-option="filterNationOption"
                      @change="handleNationChange"
                      v-model="form.nation"
                    >
                      <template v-for="item in nationMap">
                        <a-select-option :value="item.value" :key="'nation'+ item.value">
                          {{ item.name }}
                        </a-select-option>
                      </template>
                    </a-select>


                  </a-form-model-item>
                  <a-form-model-item ref="idNum" label="身份证号" prop="idNum">
                    <a-input
                      v-model="form.idNum"
                      @change="error.idNum=''"
                      @blur="
          () => {
            $refs.idNum.onFieldBlur();
          }"/>
                    <span class="text-danger" v-if="error.name">{{ error.name }}</span>
                  </a-form-model-item>

                  <a-form-model-item label="政治面貌" required prop="politics">

                    <a-select
                      show-search
                      placeholder="选择政治面貌"
                      option-filter-prop="children"
                      :filter-option="filterPoliticsOption"
                      @change="handlePoliticsChange"
                      v-model="form.politics"
                    >
                      <template v-for="item in politicsMap">
                        <a-select-option :value="item.value" :key="`pol${item.value}`">
                          {{ item.name }}
                        </a-select-option>
                      </template>

                    </a-select>


                  </a-form-model-item>

                  <a-form-model-item ref="organization" label="工作单位" prop="organization">
                    <a-input
                      v-model="form.organization"
                      @blur="
          () => {
            $refs.organization.onFieldBlur();
          }
        "
                    />
                  </a-form-model-item>
                  <a-form-model-item ref="position" label="单位职务" prop="position">
                    <a-input
                      v-model="form.position"
                      @blur="
          () => {
            $refs.position.onFieldBlur();
          }
        "
                    />
                  </a-form-model-item>
                  <a-form-model-item label="职称">
                    <a-input v-model="form.title"></a-input>
                  </a-form-model-item>

                  <a-form-model-item label="专业">
                    <a-input v-model="form.major"/>
                  </a-form-model-item>


                  <a-form-model-item ref="recname" label="推荐人姓名" prop="recname">
                    <a-input
                      placeholder="推荐人姓名"
                      v-model="form.recName"/>
                  </a-form-model-item>

                  <a-form-model-item ref="recphone" label="推荐人手机号" prop="recphone">
                    <a-input
                      placeholder="推荐人手机号"
                      v-model="form.recPhone"/>
                  </a-form-model-item>

                  <a-form-model-item ref="phone" label="手机号" prop="phone">
                    <a-input
                      v-model="form.phone"
                      @blur="() => {$refs.phone.onFieldBlur();}"/>
                  </a-form-model-item>

                  <a-form-model-item label="座机">

                    <a-input-group compact>
                      <a-input style="width: 30%" v-model="form.areacode"/>
                      <a-input style="width: 70%" v-model="form.telephone"/>
                    </a-input-group>


                  </a-form-model-item>
                  <a-form-model-item label="传真">
                    <a-input v-model="form.fax"/>
                  </a-form-model-item>
                  <a-form-model-item label="邮箱">
                    <a-input v-model="form.email"/>
                  </a-form-model-item>

                  <a-form-model-item label="地址">
                    <a-input v-model="form.address"/>
                  </a-form-model-item>

                  <a-form-model-item label="邮编">
                    <a-input v-model="form.postcode"/>
                  </a-form-model-item>

                  <a-form-model-item label="社团职务">
                    <a-input v-model="form.mass" disabled/>
                  </a-form-model-item>
                  <a-form-model-item label="当选日期" prop="elecTime">
                    <a-date-picker
                      v-model="form.elecTime"
                      @change="error.elecTime=''"
                      type="date"
                      placeholder="选择一个日期"
                      valueFormat="YYYY-MM-DD"
                      style="width: 100%;"
                      disabled
                    />
                  </a-form-model-item>
                  <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
                    <a-button type="primary" @click="toUpdateUser">
                      修改保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="modify=!modify">
                      取消
                    </a-button>
                  </a-form-model-item>

                </a-form-model>
              </a-col>
              <!--render info avatar-->
              <a-col v-else-if="selectedKeys[0]==='0'" style="padding: 2rem">
                <div>
                  <img class="custom-avatar" src="" alt="头像" :src="oldAvatar||defautAvatar"
                       @click.stop="uploadHeadImg">
                  <a-button style="margin-left: 1rem" type="primary" size="small" @click.stop="uploadHeadImg">修改头像
                  </a-button>
                  <input id="newAvatar" name="photo" accept="image/*" type="file" @change="handleFile"
                         style="display:none">
                </div>
                <a-divider></a-divider>
                <a-descriptions title="基本信息" layout="vertical">
                  <a-descriptions-item label="姓名">
                    {{ renderInfo.name || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="生日">
                    {{ renderInfo.birthday || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="性别">
                    {{ renderInfo.gender === 'male' ? '男' : '女' || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="会员编号">
                    {{ membershipId || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="会员等级">
                    {{ order || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="学会职务">
                    {{ renderInfo.mass || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="专兼职">
                    {{ renderInfo.fullPart === 'full' ? "专职" : "兼职" }}
                  </a-descriptions-item>
                  <a-descriptions-item label="手机号">
                    {{ renderInfo.phone || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="邮箱">
                    {{ renderInfo.email || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="民族">
                    {{ renderInfo.nationName || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="政治面貌">
                    {{ renderInfo.politicsName || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="职称">
                    {{ renderInfo.title || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="专业">
                    {{ renderInfo.major || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="推荐人姓名">
                    {{ renderInfo.recName || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="推荐人电话">
                    {{ renderInfo.recPhone || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="座机">
                    {{ renderInfo.areacode }}-{{ renderInfo.telephone }}
                  </a-descriptions-item>
                  <a-descriptions-item label="传真">
                    {{ renderInfo.fax || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="工作单位">
                    {{ renderInfo.organization || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="工作职位">
                    {{ renderInfo.position || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="地址">
                    {{ renderInfo.address || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="邮政编码">
                    {{ renderInfo.postcode || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="身份证号">
                    {{ showId }}
                  </a-descriptions-item>
                  <a-descriptions-item label="职务">
                    {{ renderInfo.mass || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="当选日期">
                    {{ renderInfo.elecTime || '-' }}
                  </a-descriptions-item>
                </a-descriptions>
                <a-button type="primary" @click="modify=!modify">修改个人信息</a-button>
                <div style="margin-top: 20px;">
                    <h4 style="margin-bottom: 10px;">会员证书</h4>
                    <div v-if="renderInfo.certificate">
                      <img
                        :key="certificateKey"
                        :src="renderInfo.certificate"
                        @error="handleImageError"
                        style="max-width: 400px; width: 100%; border: 1px solid #e8e8e8; border-radius: 8px; padding: 4px;"
                        alt="会员证书"
                      /><br>
                      <a-button type="primary" @click="downloadFile(renderInfo.phone+'.jpg')">下载图片</a-button>
                      <a-button type="primary" @click="downloadFile(renderInfo.phone+'.pdf')">下载pdf</a-button>
                    </div>

                    <div v-else style="color: #999; padding: 20px 0;">
                      暂无证书
                    </div>
                </div>
              </a-col>
              <!--password modify-->
              <a-col
                :span="24"
                :xxl="{span:16}"
                :xl="{span:16}"
                :lg="{span:16}"
                :md="{span:24}"
                style="padding:2rem"
                v-if="selectedKeys[0]==='1'">

                <a-form-model ref="passForm"
                              :model="passForm"
                              :rules="rules"
                              :label-col="labelCol"
                              :wrapper-col="wrapperCol">
                  <a-card>
                    <h3 style="text-align: center">修改密码</h3>
                    <a-divider></a-divider>
                    <a-form-model-item ref="password" label="新密码" autocomplete="off" prop="password">
                      <a-input-password v-model="passForm.password" placeholder="请输入密码"/>
                    </a-form-model-item>
                    <a-form-model-item ref="password2" label="重复密码" autocomplete="off" prop="password2">
                      <a-input-password v-model="passForm.password2" placeholder="请再次输入密码"/>
                      <span class="text-danger" v-if="passwordErr">{{ passwordErr }}</span>
                    </a-form-model-item>
                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
                      <a-button type="primary" @click="toUpdatePass">
                        修改保存
                      </a-button>
                      <a-button style="margin-left: 10px;" @click="resetForm">
                        取消
                      </a-button>
                    </a-form-model-item>
                  </a-card>
                </a-form-model>
              </a-col>
            </a-row>


          </a-layout-content>
        </a-layout>
      </a-layout-content>

    </a-layout>
  </div>
</template>

<script>
import {getUserOrganization, getUserPerson, updateUserOrganization, updateUserPerson} from "../../api/api";
import {filterUnderLine, toUnderLineObj} from "../../../static/js/util";
import cookie from "../../../static/js/cookie";
import axios from 'axios';
import message from 'ant-design-vue/lib/message';
import 'ant-design-vue/lib/message/style/css';

export default {
  name: "UserCenter",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
        if (this.passForm.password !== '') {
          callback();
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passForm.password) {
        callback(new Error("两次输入的密码不相同!"));
      } else {
        callback();
      }
    };
    return {
      userInfo: this.$store.getters.userInfo,
      defautAvatar: '/scff/static/imgs/avatar.png',
      oldAvatar: '',
      membershipId: '',
      order: '',
      certificateKey: 0,
      imageLoadError: false,
      renderInfo: {
        name: '',
        organization: '',
        position: '',
        title: '',
        phone: '',
        areacode: '',
        telephone: '',
        email: '',
        birthday: '',
        address: '',
        postcode: '',
        gender: '',
        major: '',
        recName: '',
        recPhone: '',
        fax: '',
        mass: '',
        idNum: '',
        nationName: '',
        politicsName: '',
        fullPart: '',
        certificate: '',
        elecTime: "",
      },
      passwordErr: '',
      labelCol: {span: 6},
      modify: false,
      wrapperCol: {span: 14},
      selectedKeys: ['0'],
      avatar: '',
      avatarUrl: '',
      error: {
        name: '',
        organization: '',
        position: '',
        title: '',
        phone: '',
        areacode: '',
        telephone: '',
        email: '',
        password: '',
        birthday: '',
        address: '',
        postcode: '',
        gender: '',
        major: '',
        recName: '',
        recPhone: '',
        fax: '',
        elecTime: '',
      },
      form: {
        name: '',
        organization: '',
        position: '',
        title: '',
        phone: '',
        areacode: '',
        telephone: '',
        email: '',
        password: '',
        birthday: undefined,
        address: '',
        postcode: '',
        gender: '',
        recName: '',
        recPhone: '',
        major: '',
        fax: '',
        mass: '',
        idNum: '',
        nation: '',
        politics: '',
        elecTime: '',
      },
      passForm: {
        password: '',
        password2: ''
      },
      nationMap: [
        {value: "1", name: "汉族"},
        {value: "2", name: "蒙古族"},
        {value: "3", name: "回族"},
        {value: "4", name: "藏族"},
        {value: "5", name: "维吾尔族"},
        {value: "6", name: "苗族"},
        {value: "7", name: "彝族"},
        {value: "8", name: "壮族"},
        {value: "9", name: "布依族"},
        {value: "10", name: "朝鲜族"},
        {value: "11", name: "满族"},
        {value: "12", name: "侗族"},
        {value: "13", name: "瑶族"},
        {value: "14", name: "白族"},
        {value: "15", name: "土家族"},
        {value: "16", name: "哈尼族"},
        {value: "17", name: "哈萨克族"},
        {value: "18", name: "傣族"},
        {value: "19", name: "黎族"},
        {value: "20", name: "傈傈族"},
        {value: "21", name: "佤族"},
        {value: "22", name: "畲族"},
        {value: "23", name: "高山族"},
        {value: "24", name: "拉祜族"},
        {value: "25", name: "水族"},
        {value: "26", name: "东乡族"},
        {value: "27", name: "纳西族"},
        {value: "28", name: "景颇族"},
        {value: "29", name: "柯尔克孜族"},
        {value: "30", name: "土族"},
        {value: "31", name: "达翰尔族"},
        {value: "32", name: "仫佬族"},
        {value: "33", name: "布朗族"},
        {value: "34", name: "撒拉族"},
        {value: "35", name: "毛南族"},
        {value: "36", name: "仡佬族"},
        {value: "37", name: "锡伯族"},
        {value: "38", name: "阿昌族"},
        {value: "39", name: "普米族"},
        {value: "40", name: "塔吉克族"},
        {value: "41", name: "怒族"},
        {value: "42", name: "怒族"},
        {value: "43", name: "乌兹别克族"},
        {value: "44", name: "俄罗斯族"},
        {value: "45", name: "鄂温克族"},
        {value: "46", name: "德昂族"},
        {value: "47", name: "保安族"},
        {value: "48", name: "裕固族"},
        {value: "49", name: "京族"},
        {value: "50", name: "塔塔尔族"},
        {value: "51", name: "独龙族"},
        {value: "52", name: "鄂伦春族"},
        {value: "53", name: "赫哲族"},
        {value: "54", name: "珞巴族"},
        {value: "55", name: "基诺族"},
        {value: "56", name: "其它"}
      ],
      politicsMap: [
        {value: "1", name: "群众"},
        {value: "2", name: "中国共产党党员"},
        {value: "3", name: "中国农民民主党党员"},
        {value: "4", name: "中国致公党党员"},
        {value: "5", name: "中国共产党预备党员"},
        {value: "6", name: "九三学社社员"},
        {value: "7", name: "中国台湾同盟盟员"},
        {value: "8", name: "无党派民主人士"},
        {value: "9", name: "中国共产主义共青团团员"},
        {value: "10", name: "中国国民党革命委员会党员"},
        {value: "11", name: "中国民主同盟盟员"},
        {value: "12", name: "中国民主建国会委员"},
        {value:"13", name:"中国民主促进会会员"}
      ],
      rules: {
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '姓名位2-20个字符', trigger: 'blur'},
        ],
        organization: [
          {required: true, message: '工作单位不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '工作单位2-20个字符', trigger: 'blur'},
        ],
        position: [
          {required: true, message: '单位职务不能为空', trigger: 'blur'},
        ],

        phone: [
          {required: true, message: '手机号不能为空', trigger: 'blur'},
        ],
        birthday: [{required: true, message: '请选择一个日期', trigger: 'change'}],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        idNum: [
          {required: true, message: '身份证号不能为空', trigger: 'blur'},
          {min: 17, max: 20, message: '身份证号17-20个字符', trigger: 'blur'},
        ],
        politics: [{required: true, message: '政治面貌必须填写', trigger: 'blur'}],
        nation: [{required: true, message: '民族必须填写', trigger: 'blur'}],
        password: [{validator: validatePass, trigger: 'change'}],
        password2: [{validator: validatePass2, trigger: 'change'}],

      }
    }
  },
  computed: {
    showId() {
      if (this.renderInfo.idNum) {
        var val = this.renderInfo.idNum
        return val.substring(0, 6) + '****' + val.substring(val.length - 4, val.length)
      } else {
        return '-'
      }
    }
  },

  methods: {
    // ✅ 获取用户ID的辅助方法 - 直接使用 uid
    getUserId: function() {
      // ✅ 只使用 uid（User 表的 ID），不使用 member_id
      var uid = this.userInfo.uid || cookie.getCookie('uid');
      return uid;
    },

    handleImageError: function() {
      this.imageLoadError = true;
      this.certificateKey += 1;
      this.renderInfo.certificate = null;
    },
    checkImageExists: function(url) {
      return new Promise(function(resolve) {
        var img = new Image();
        img.onload = function() { resolve(true); };
        img.onerror = function() { resolve(false); };
        img.src = url;
      });
    },
    getAuthToken: function() {
      return localStorage.getItem('token');
    },
    downloadImage: function() {
      var fileName = this.membershipId + '.jpg';
      this.downloadFile(fileName);
    },

    downloadPDF: function() {
      var fileName = this.membershipId + '.pdf';
      this.downloadFile(fileName);
    },

    downloadFile: function(fileName) {
      var that = this;
      try {
        var token = this.getAuthToken();

        axios({
          method: 'get',
          url: '/download/',
          params: { file_name: fileName },
          responseType: 'blob',
          headers: token ? { 'Authorization': 'Token ' + token } : {}
        }).then(function(response) {
          var blob = new Blob([response.data]);
          var link = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);

          message.success('下载成功');
        }).catch(function(error) {
          console.error('下载失败:', error);
          if (error.response && error.response.status === 401) {
            message.error('请先登录');
          } else if (error.response && error.response.status === 403) {
            message.error('无权限下载该文件');
          } else {
            message.error('下载失败，请重试');
          }
        });
      } catch (error) {
        console.error('下载失败:', error);
        message.error('下载失败，请重试');
      }
    },

    fetchUserInfo: function() {
      // ✅ 使用辅助方法获取 ID
      var id = this.getUserId();

      console.log('=== fetchUserInfo 开始 ===');
      console.log('使用的 ID:', id);
      console.log('userInfo:', this.userInfo);

      if (!id) {
        console.warn('用户ID不存在，请重新登录')
        message.warning('请重新登录')
        this.$router.push({name: 'login'})
        return;
      }

      var that = this;
      getUserPerson(id).then(function(res) {
        var arr = filterUnderLine(res.data)
        console.log('获取到的用户数据:', arr);

        // ✅ 不使用可选链操作符
        that.membershipId = (arr.user && (arr.user.membershipId || arr.user.membership_id)) || '-'
        that.order = (arr.user && arr.user.order) || '-'
        that.oldAvatar = arr.avatar || that.defautAvatar
        that.renderInfo.name = arr.name || ''
        that.renderInfo.organization = arr.organization || ''
        that.renderInfo.position = arr.position || ''
        that.renderInfo.title = arr.title || ''
        that.renderInfo.phone = arr.phone || ''
        that.renderInfo.areacode = arr.areacode || ''
        that.renderInfo.telephone = arr.telephone || ''
        that.renderInfo.email = arr.email || ''
        that.renderInfo.password = arr.password || ''
        that.renderInfo.birthday = arr.birthday || ''
        that.renderInfo.address = arr.address || ''
        that.renderInfo.postcode = arr.postcode || ''
        that.renderInfo.gender = arr.gender || ''
        that.renderInfo.major = arr.major || ''
        that.renderInfo.recName = arr.recName || ''
        that.renderInfo.recPhone = arr.recPhone || ''
        that.renderInfo.fax = arr.fax || ''
        that.renderInfo.idNum = arr.idNum || ''
        that.renderInfo.politicsName = arr.politicsName || ''
        that.renderInfo.nationName = arr.nationName || ''
        that.renderInfo.fullPart = arr.fullPart || 'part'
        that.renderInfo.mass = arr.mass || ''
        that.renderInfo.nation = arr.nation || ''
        that.renderInfo.politics = arr.politics || ''

        var elecTimeVal = arr.elecTime || arr.elec_time || ''
        if (elecTimeVal) {
          elecTimeVal = elecTimeVal.split('T')[0]
        }
        that.renderInfo.elecTime = elecTimeVal

        if (arr.certificate) {
          var separator = arr.certificate.indexOf('?') !== -1 ? '&' : '?'
          that.renderInfo.certificate = arr.certificate + separator + 't=' + new Date().getTime()
        } else {
          that.renderInfo.certificate = arr.certificate || ''
        }

        that.certificateKey += 1
        that.form = JSON.parse(JSON.stringify(that.renderInfo))
        that.form.elecTime = that.renderInfo.elecTime

        console.log('数据加载完成，当选日期:', that.form.elecTime)
      }).catch(function(err) {
        console.error('获取用户信息失败:', err)
        if (err.response && err.response.status === 401) {
          message.error('登录已过期，请重新登录')
          that.$router.push({name: 'login'})
        } else {
          message.error('获取用户信息失败，请重试')
        }
      })
    },

    toUpdateUser: function() {
      var that = this;
      this.$refs.ruleForm.validate(function(valid) {
        if (valid) {
          try {
            var formData = JSON.parse(JSON.stringify(that.form))
            if (formData.elecTime) {
              if (formData.elecTime.length === 10 && formData.elecTime.indexOf('T') === -1) {
                formData.elecTime = formData.elecTime + 'T00:00:00'
              }
            }

            var params = toUnderLineObj(formData)
            delete params.certificate
            delete params.add_time
            delete params.update_time
            delete params.pwd_change

            console.log('提交的数据:', params)
            console.log('当选日期 (elec_time):', params.elec_time)

            // ✅ 使用 uid（User 表的 ID）
            var userId = that.userInfo.uid || cookie.getCookie('uid');

            updateUserPerson(userId, params).then(function(res) {
              message.success('个人信息修改成功')
              that.modify = false

              // ✅ 延迟后重新获取用户信息
              setTimeout(function() {
                that.fetchUserInfo()
              }, 1000)

            }).catch(function(err) {
              console.error('修改失败:', err)
              if (err.response && err.response.data) {
                var errorData = err.response.data
                var errorMsg = ''
                for (var key in errorData) {
                  if (Array.isArray(errorData[key])) {
                    errorMsg += key + ': ' + errorData[key].join(' ') + '\n'
                  } else {
                    errorMsg += key + ': ' + errorData[key] + '\n'
                  }
                }
                message.error('信息修改失败：' + errorMsg)
              } else {
                message.error('信息修改失败，请重试')
              }
            })
          } catch (error) {
            console.error('处理数据失败:', error)
            message.error('数据处理失败，请重试')
          }
        }
      })
    },
    toUpdatePass: function() {
      var that = this;
      this.$refs.passForm.validate(function(valid) {
        if (valid) {
          var params = {
            password: that.passForm.password,
            password2: that.passForm.password2
          }
          // ✅ 使用 uid（User 表的 ID）
          var userId = that.userInfo.uid || cookie.getCookie('uid');

          updateUserPerson(userId, params).then(function(res) {
            message.success('密码修改成功，请重新登录')
            cookie.delCookie('token')
            cookie.delCookie('name')
            cookie.delCookie('uid')
            cookie.delCookie('mid')
            cookie.delCookie('part')
            cookie.delCookie('id')

            that.$store.dispatch('setInfo');
            that.$store.dispatch('setPerson');
            that.$store.dispatch('setOrg');
            that.$store.dispatch('setUrl', '')

            that.$router.push({name: 'scf'})

          }).catch(function(err) {
            if ("password" in err) {
              that.passwordErr = err.password[0];
            }
            console.log(err)
          })
        } else {
          console.log('修改密码失败!!');
          return false;
        }
      });

    },
    resetForm: function() {
      this.$refs.ruleForm.resetFields();
    },

    uploadHeadImg: function() {
      document.getElementById("newAvatar").click()
    },
    handleFile: function(e) {
      var that = this;
      var $target = e.target
      var file = $target.files[0]
      this.avatar = file
      var reader = new FileReader()
      reader.onload = function(data) {
        var res = data.target
        that.oldAvatar = res.result
      }
      var data = new FormData()
      data.append('avatar', this.avatar)

      // ✅ 使用 uid（User 表的 ID）
      var userId = this.userInfo.uid || cookie.getCookie('uid');

      updateUserPerson(userId, data).then(function(res) {
        message.success('头像修改成功')
        reader.readAsDataURL(file)
        // ✅ 重新获取用户信息
        setTimeout(function() {
          that.fetchUserInfo()
        }, 500)
      }).catch(function(err) {
        message.error('头像修改失败')
        console.log(err)
      })
    },
    handleNationChange: function(value) {
      this.form.nation = value
    },
    filterNationOption: function(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePoliticsChange: function(value) {
      this.form.politics = value
    },
    filterPoliticsOption: function(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted: function() {
    console.log('=== UserCenter mounted ===');

    var that = this;
    // ✅ 从 cookie 重新加载 userInfo（确保数据最新）
    this.$store.dispatch('setInfo', {
      name: cookie.getCookie('name'),
      token: cookie.getCookie('token'),
      uid: cookie.getCookie('uid'),
      part: cookie.getCookie('part'),
      mid: cookie.getCookie('mid'),
      id: cookie.getCookie('id'),
      member_id: cookie.getCookie('member_id'),
      user_id: cookie.getCookie('user_id'),
    });

    // ✅ 延迟一下再获取，确保 store 已更新
    this.$nextTick(function() {
      that.fetchUserInfo()
    });
  }
}
</script>

<style scoped>
.custom-avatar {
  height: 6rem;
  width: 6rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserCenter.vue